import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { getAssetShareclassTerms } from '../../actions/assetDetailsActions';

export const AssetTermsList = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const shareclassterms= useSelector((state) => state.assetShareClassTerms.assetShareClassTerms);
    useEffect(() => {
        dispatch(getAssetShareclassTerms(params.Asset));
    }, []);

    return (
        <div class="card-body p-0">

        <div class="row p-3 border-bottom  m-0">
            <div class="col-6 left">
                <span>Share Class</span>
            </div>
            <div class="col-6 text-sm-end fw-medium">
                <span>{shareclassterms.ShareClassName ? shareclassterms.ShareClassName : 'NA'}</span>
            </div>
        </div>
        <div class="row p-3 border-bottom  m-0">
                <div class="col-6 left">
                    <span>Management Fee</span>
            </div>
            <div class="col-6 text-sm-end fw-medium">
                <span>{shareclassterms.MgmtFee? shareclassterms.MgmtFee+ '%' : 'NA'}</span>
            </div>
        </div>
            <div class="row p-3 border-bottom m-0">
            <div class="col-6 left">
                    <span>Performance Fee </span>
            </div>
            <div class="col-6 text-sm-end fw-medium">
            
                <span>{shareclassterms.PerfFee? shareclassterms.PerfFee + '%' : 'NA'}</span>
            </div>
            </div>
            <div class="row p-3  border-bottom m-0" style={{ width: '100%' }}>
                <div class="col-6 left">
                    <span>Performance Fee Description</span>
            </div>
                <div class="col-6 text-sm-end fw-medium">
            
                <span>{shareclassterms.PerfFeeDesc? shareclassterms.PerfFeeDesc :'NA'}</span>
            </div>
        </div>
            <div class="row p-3 border-bottom  m-0">
            <div class="col-6 left">
                <span>Liquidity</span>
            </div>
            <div class="col-6 text-sm-end fw-medium">
            
                <span>{shareclassterms.LiquidityTerm? shareclassterms.LiquidityTerm : 'NA'}</span>
            </div>
        </div>
                </div>
             
    )
}
